import { Chip, Stack } from '@mui/material';
import type { BaseIntegrationEntity } from '@vy/types';
import { type ContractStatus, type Plan, INTEGRATION_PROVIDERS, SYNC_STATUSES } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import React from 'react';
import { ContractStatusChip } from '../../../../../components/design/ContractStatusChip';
import { getSyncStatusIcon } from '../../../../../pages/invoices/InvoicesPage/invoices-page-components/InvoiceSyncStatusLabel/InvoiceSyncStatusLabel';
import { formatDate } from '../../../../../utils/date';
import { formatTrialDays } from '../contract-page-header-utils/contract-page-formatter';
import { useIntegrationSyncStatus } from '../../../../../hooks/use-integration-sync-status';

type ContractInfoHeaderProps = {
  plan: Plan;
  status: ContractStatus;
  contractEndDate?: Date;
  integrationEntities?: BaseIntegrationEntity[];
};

export const ContractInfoHeader: React.FC<ContractInfoHeaderProps> = ({
  plan,
  status,
  contractEndDate,
  integrationEntities,
}) => {
  const { syncStatus, syncStatusUpdatedAt } = useIntegrationSyncStatus(
    integrationEntities ?? [],
    INTEGRATION_PROVIDERS.netSuite,
  );

  const isSalesforceSync = syncStatus === SYNC_STATUSES.Synced;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mt: 2,
        width: "100%",
        flexGrow: 1
      }}>
      <ContractStatusChip
        status={status}
        endDate={contractEndDate}
        style={{ padding: '7px 10px' }}
        placement="bottom"
      />
      {plan.billingData.autoRenewal && <Chip label="Auto Renew" size="medium" />}
      {isNotNullOrUndefined(plan.trial) && (
        <Chip label={`${formatTrialDays(plan.trial)} Days Trial`} size="medium" />
      )}
      {isSalesforceSync && (
        <Chip
          size="medium"
          label={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '4px' }}>ERP Sync</span>
              {getSyncStatusIcon(syncStatus, formatDate(syncStatusUpdatedAt))}
            </div>
          }
        />
      )}
    </Stack>
  );
};
